import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "uom";

const initialState = {
  loading: null,
  uomList: [],
  uomResponse: {},
  errorMessage: null,
};

// POST
export const addUoMToServer = createAsyncThunk(
  `${namespace}/addUoMToServer`,
  async (newUoM, { rejectWithValue }) => {
    try {
      const response = await api.post("/uom", newUoM, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getUoMFromServer = createAsyncThunk(
  `${namespace}/getUoMFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/uom", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getUoMCountFromServer = createAsyncThunk(
  `${namespace}/getUoMCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/uomCount", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getUoMFromServerByPagination = createAsyncThunk(
  `${namespace}/getUoMFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/uompagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// PATCH
export const updateUoMInServer = createAsyncThunk(
  `${namespace}/updateUoMInServer`,
  async (updatedUoM, { rejectWithValue }) => {
    try {
      const id = parseInt(updatedUoM.uomId);
      const response = await api.patch(`/uom/${id}`, updatedUoM, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// DELETE
export const deleteUoMFromServer = createAsyncThunk(
  `${namespace}/deleteUoMFromServer`,
  async (existingUoM, { rejectWithValue }) => {
    try {
      const id = parseInt(existingUoM.uomid);
      const loginUser = existingUoM.loginUser;
      const response = await api.patch(
        `/deleteuom/${id}`,
        { params: { loginUser } },
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const uomSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUoMFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getUoMFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.uomList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getUoMFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.uomList = [];
        state.errorMessage = error.message;
      })
      .addCase(getUoMCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getUoMCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getUoMCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage1;
      })
      .addCase(getUoMFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getUoMFromServerByPagination.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getUoMFromServerByPagination.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.uomList = [];
        state.errorMessage = error.message;
      })
      .addCase(addUoMToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addUoMToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.uomResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(addUoMToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.uomResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(updateUoMInServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateUoMInServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.uomResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateUoMInServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.uomResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(deleteUoMFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(deleteUoMFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.uomResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(deleteUoMFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.uomResponse = {};
        state.errorMessage = error.message;
      });
  },
});

export const selectAllUoM = (state) => state.uoms.uomList;
export const selectLoadingStatus = (state) => state.uoms.loading;
export default uomSlice.reducer;
